export default __webpack_public_path__ + "static/articles-stavien-sinovialna-stava-cb1a89d83bc8a776897b9464da9160e1.jpg";